class Context {
  // May be FluxDispatcher
  dispatcher: any;
  sessionStore: any;
  userStore: any;

  constructor() {
    this.dispatcher = null;
    this.sessionStore = null;
    this.userStore = null;
  }

  setDispatcher(dispatcher) {
    this.dispatcher = dispatcher;
  }

  getDispatcher() {
    return this.dispatcher;
  }

  setSessionStore(sessionStore) {
    this.sessionStore = sessionStore;
  }

  setUserStore(userStore) {
    this.userStore = userStore;
  }

  getUserStore() {
    return this.userStore;
  }

  checkTokenExpired() {
    const token = this.userStore.service.getToken();

    // note: string 'undefined' is intentional... this is the value of the
    // token in localStorage when it expires
    const isTokenExpired = !token || token === 'undefined';

    if (isTokenExpired) {
      localStorage.setItem('showExpiredTokenMessage', 'true');
      this.userStore.service.logout(window?.location?.reload());
    }
  }
}

export default new Context();
